<script>    
    export let onClick = () => {}
    export let id = null
    export let src
    export let width
    export let height
    export let alt = ''
</script>

<img {id} {src} {width} {height} {alt} on:click={onClick} />